import deriveLinkComponents from '../associations/derive-link-components';
import api from '../REST/api';
import BrandLink from './BrandLink';

const { Link, Links } = deriveLinkComponents(BrandLink, api.getBrand);

export { Link as BrandLink, Links as BrandLinks };
